import { render } from "./MailingTelegram.vue?vue&type=template&id=67a12006&scoped=true"
import script from "./MailingTelegram.vue?vue&type=script&lang=js"
export * from "./MailingTelegram.vue?vue&type=script&lang=js"

import "./MailingTelegram.vue?vue&type=style&index=0&id=67a12006&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67a12006"]])

export default __exports__